exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".media-upload{font-size:26px;min-width:50px}.icon-upload{cursor:pointer}", ""]);

// exports
